export { default } from './AboutCard';
